module.exports = __webpack_public_path__ + "static/media/14.c25a4fee.png";